import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { API_URL } from './env'
import { Helmet } from 'react-helmet'
import Router from './Router'
import axios from 'axios'
import publicIp from 'react-public-ip'
import { useAxiosInterceptor } from './axiosInterceptor'
import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/colors.css'
import './App.css'
import Nav from './components/Nav'
import Footer from './components/Footer'

function App() {

    const location = useLocation()
    useAxiosInterceptor()
    const [ip, setIp] = useState(null)
    const [version, setVersion] = useState(null)

    useEffect(() => {

        getIp()
        getVersion()
        addView()

    }, [])


    async function getIp() {

        const ipv4 = await publicIp.v4()
        const ipv6 = await publicIp.v6()
        if (ipv4) {
            setIp(ipv4)
        } else {
            setIp(ipv6)
        }

    }

    function getVersion() {

        const today = new Date()
        const timestamp = today.getTime()
        setVersion("1.0-" + timestamp)

    }

    function addView() {

        if (!location.pathname.startsWith('/paiement') && !location.pathname.startsWith('/diagnostic/PDFVerification/') && !location.pathname.startsWith('/administration') && !location.pathname.startsWith('/authentification')) {
            axios.post(API_URL + "statistic/view").then().catch((error) => {
                console.log("error :\n" + JSON.stringify(error) + "\n\n")
            })
        }

    }

    return (

        <div className="App">
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="theme-color" content="#000000" />
                <meta name="version" content={version} data-react-helmet="true" />
                <meta name="robots" content="index, follow" />
                <meta name="author" content="Acheter-louer.fr" />
                <meta property="og:type" content="website" />
            </Helmet>
            {!location.pathname.startsWith('/administration/') && location.pathname !== '/authentification' && !location.pathname.startsWith('/paiement/') && !location.pathname.startsWith('/diagnostic/PDFVerification/') ?
                <>
                    <Nav />
                    <Router ip={ip} />
                    <Footer ip={ip} />
                </>
                :
                <Router ip={ip} />
            }
        </div>

    )

    // }

}

export default App